import React from 'react';
import PropTypes from 'prop-types';

function NumberInput({
  fieldName,
  register,
  errors,
  isRequired,
  placeHolder,
  defaultValue,
  className,
  labelstyle,
  labeldarkstyle,
  classNamedark,
  maximLength,
  minimLength,
  label,
  mandatory,
  readOnly,
  id,
  positiveIntegersOnly,
}) {
  let classNames = labelstyle;
  let classNamess = className;

  if (localStorage.getItem('theme') === 'dark') {
    classNames = labeldarkstyle;
    classNamess = classNamedark;
  }

  const handleKeyDown = (e) => {
    if (positiveIntegersOnly && ['e', 'E', '+', '-', '.'].includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleKeyPress = (event) => {
    if (positiveIntegersOnly) {
      if (event.key === '0' && !event.target.value) {
        event.preventDefault();
        return;
      }
    }
    if (!/^[0-9]+$/.test(event.key)) {
      event.preventDefault();
    }
  };

  const handleChange = (e) => {
    if (positiveIntegersOnly) {
      const raw = e.target.value;
      if (raw === '') return;
      const digitsOnly = raw.replace(/\D/g, '');
      const sanitized = digitsOnly.replace(/^0+/, '') || '';
      if (raw !== sanitized) {
        e.target.value = sanitized;
      }
    }
  };

  const defaultMax = positiveIntegersOnly ? 10 : 3;
  const defaultMin = positiveIntegersOnly ? 1 : 2;
  const registerOptions = {
    required: {
      value: isRequired,
      message: `${label} is required`,
    },
    maxLength: {
      value: maximLength ?? defaultMax,
      message: `Value must be maximum ${maximLength ?? defaultMax} digit value.`,
    },
    minLength: {
      value: minimLength ?? defaultMin,
      message: `Value must be minimum ${minimLength ?? defaultMin} digit value.`,
    },
  };

  const registered = register(fieldName ?? 'Number', registerOptions);
  const combinedOnChange = positiveIntegersOnly
    ? (e) => {
        handleChange(e);
        registered.onChange(e);
      }
    : registered.onChange;

  return (
    <div className="form-field">
      <label htmlFor={fieldName} className={classNames ?? labelstyle}>
        {label ?? 'Number field'}
      </label>
      {mandatory || isRequired ? <span style={{ color: 'red' }}>*</span> : <span />}
      <input
        type="text"
        inputMode={positiveIntegersOnly ? 'numeric' : undefined}
        maxLength={maximLength}
        defaultValue={defaultValue}
        className={classNamess ?? className}
        placeholder={placeHolder}
        readOnly={readOnly}
        onKeyDown={positiveIntegersOnly ? handleKeyDown : undefined}
        onKeyPress={handleKeyPress}
        onChange={combinedOnChange}
        id={id}
        aria-label={positiveIntegersOnly ? 'Positive integers only (e.g. 1, 2, 100)' : undefined}
        ref={registered.ref}
        name={registered.name}
        onBlur={registered.onBlur}
      />

      <p
        style={{
          color: 'red',
          marginTop: '5px',
          fontSize: '14px',
        }}
      >
        {' '}
        {
          // Shows if error exist
          errors[fieldName] && errors[fieldName].message
        }{' '}
      </p>
    </div>
  );
}

NumberInput.propTypes = {
  fieldName: PropTypes.element.isRequired,
  register: PropTypes.element.isRequired,
  errors: PropTypes.oneOfType([PropTypes.object]).isRequired,
  placeHolder: PropTypes.element,
  isRequired: PropTypes.element,
  maximLength: PropTypes.element,
  minimLength: PropTypes.element,
  label: PropTypes.element,
  mandatory: PropTypes.element,
  className: PropTypes.string,
  defaultValue: PropTypes.string,
  labeldarkstyle: PropTypes.string,
  classNamedark: PropTypes.string,
  labelstyle: PropTypes.string.isRequired,
  id: PropTypes.string,
  readOnly: PropTypes.bool,
  positiveIntegersOnly: PropTypes.bool,
};
NumberInput.defaultProps = {
  mandatory: false,
  isRequired: false,
  placeHolder: 'Enter Value',
  maximLength: 10,
  minimLength: 1,
  label: 'Number Input',
  classNamedark: null,
  labeldarkstyle: null,
  className: 'default-input-class',
  defaultValue: null,
  id: '',
  readOnly: false,
  positiveIntegersOnly: false,
};
export default NumberInput;
